module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main situation"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "leftContent"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.model,
      "status-icon": "",
      "rules": _vm.rules
    }
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeNamesFirst),
      callback: function($$v) {
        _vm.activeNamesFirst = $$v
      },
      expression: "activeNamesFirst"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "个人信息",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("所属单位")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "organizationId"
    }
  }, [_c('el-select', {
    staticClass: "select_w100",
    attrs: {
      "placeholder": "全部",
      "filterable": ""
    },
    model: {
      value: (_vm.model.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.model, "organizationId", $$v)
      },
      expression: "model.organizationId"
    }
  }, _vm._l((_vm.organizationList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.simpName,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("账号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入账号"
    },
    model: {
      value: (_vm.model.username),
      callback: function($$v) {
        _vm.$set(_vm.model, "username", $$v)
      },
      expression: "model.username"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("密码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.checked && !!_vm.val.id,
      "type": "password",
      "show-password": "",
      "placeholder": "请输入密码"
    },
    on: {
      "blur": _vm.passwordBlur
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("确认密码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    staticClass: " margin-right-15",
    attrs: {
      "disabled": !_vm.checked && !!_vm.val.id,
      "type": "password",
      "show-password": "",
      "placeholder": "请输入确认密码"
    },
    model: {
      value: (_vm.model.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.model, "checkPass", $$v)
      },
      expression: "model.checkPass"
    }
  })], 1), _vm._v(" "), (!!_vm.val.id) ? _c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("重置密码")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("姓名")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "realname"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.model.realname),
      callback: function($$v) {
        _vm.$set(_vm.model, "realname", $$v)
      },
      expression: "model.realname"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("手机号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.model.phone),
      callback: function($$v) {
        _vm.$set(_vm.model, "phone", $$v)
      },
      expression: "model.phone"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("性别")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.model.gender),
      callback: function($$v) {
        _vm.$set(_vm.model, "gender", $$v)
      },
      expression: "model.gender"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.model.gender),
      callback: function($$v) {
        _vm.$set(_vm.model, "gender", $$v)
      },
      expression: "model.gender"
    }
  }, [_vm._v("女")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("身份证号码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "identityCardNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.model.identityCardNo),
      callback: function($$v) {
        _vm.$set(_vm.model, "identityCardNo", $$v)
      },
      expression: "model.identityCardNo"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("警员号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入警员号"
    },
    model: {
      value: (_vm.model.policeNo),
      callback: function($$v) {
        _vm.$set(_vm.model, "policeNo", $$v)
      },
      expression: "model.policeNo"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("账号状态")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.model.block) + "\n\t\t\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("所属保险公司")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        _vm.insuranceShow = true
      }
    },
    model: {
      value: (_vm.model.insuranceCompanyName),
      callback: function($$v) {
        _vm.$set(_vm.model, "insuranceCompanyName", $$v)
      },
      expression: "model.insuranceCompanyName"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "danger",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": _vm.removeCompanyName
    }
  }, [_vm._v("删除")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("岗位角色")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32 checkcase"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.roleNames),
      callback: function($$v) {
        _vm.roleNames = $$v
      },
      expression: "roleNames"
    }
  }, _vm._l((_vm.roleCheckList), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.roleName,
        "disabled": item.isDisabled
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("角色身份")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtNames),
      expression: "districtNames"
    }],
    staticClass: "input margin-right-15",
    attrs: {
      "disabled": true,
      "type": "text",
      "placeholder": "请输入角色身份"
    },
    domProps: {
      "value": (_vm.districtNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.districtNames = $event.target.value
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectRoles
    }
  }, [_vm._v("选择角色身份")]), _vm._v(" "), _c('span', {
    staticClass: "ml12"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "定责民警"
    },
    model: {
      value: (_vm.dingzePoliceAuth),
      callback: function($$v) {
        _vm.dingzePoliceAuth = $$v
      },
      expression: "dingzePoliceAuth"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "ml12"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "接收预约短信"
    },
    model: {
      value: (_vm.receiveMsgStatus),
      callback: function($$v) {
        _vm.receiveMsgStatus = $$v
      },
      expression: "receiveMsgStatus"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("文书修改")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "修改申请"
    },
    model: {
      value: (_vm.accidentEditAuth),
      callback: function($$v) {
        _vm.accidentEditAuth = $$v
      },
      expression: "accidentEditAuth"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "修改审批"
    },
    model: {
      value: (_vm.accidentExamineAuth),
      callback: function($$v) {
        _vm.accidentExamineAuth = $$v
      },
      expression: "accidentExamineAuth"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("审批领导")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.examineLeaderName),
      expression: "model.examineLeaderName"
    }],
    staticClass: "input margin-right-15",
    attrs: {
      "type": "text",
      "placeholder": "请选择审批领导"
    },
    domProps: {
      "value": (_vm.model.examineLeaderName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "examineLeaderName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.selectLeader
    }
  }, [_vm._v("选择审批领导")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("安全验证")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "人脸核验"
    },
    model: {
      value: (_vm.faceDisabled),
      callback: function($$v) {
        _vm.faceDisabled = $$v
      },
      expression: "faceDisabled"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "授权码核验"
    },
    model: {
      value: (_vm.needAuthConfirm),
      callback: function($$v) {
        _vm.needAuthConfirm = $$v
      },
      expression: "needAuthConfirm"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("授权码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入授权码",
      "maxlength": "120",
      "resize": "none",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.model.authorizationDevice),
      callback: function($$v) {
        _vm.$set(_vm.model, "authorizationDevice", $$v)
      },
      expression: "model.authorizationDevice"
    }
  })], 1)])])])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesThird),
      callback: function($$v) {
        _vm.activeNamesThird = $$v
      },
      expression: "activeNamesThird"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "图章上传",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "wholeAcccindentClass"
  }, [_c('div', {
    staticClass: "accidentImages"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-box"
  }, [(_vm.accidentImg) ? _c('div', [(/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(_vm.accidentImg)) ? _c('div', {
    staticClass: "video-wrap"
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.accidentImg, ''),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.accidentImg)
      }
    }
  })]) : _c('div', {
    staticClass: "img-mask-no"
  }, [(!_vm.accidentImg) ? _c('i', {
    staticClass: "el-icon-upload"
  }) : _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.accidentImg)
      }
    }
  }), _vm._v(" "), (!_vm.accidentImg) ? _c('div', [_vm._v("上传图片")]) : _vm._e()])]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".jpg,.jpeg,.png",
      "action": _vm.action,
      "auto-upload": false,
      "headers": _vm.headers,
      "show-file-list": false,
      "on-change": _vm.handleChange,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.uploadSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "警民联系",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "wholeAcccindentClass"
  }, [_c('div', {
    staticClass: "accidentImages"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-box"
  }, [(_vm.contactImg) ? _c('div', [(/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(_vm.contactImg)) ? _c('div', {
    staticClass: "video-wrap"
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.contactImg, 1),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.contactImg)
      }
    }
  })]) : _c('div', {
    staticClass: "img-mask-no"
  }, [(!_vm.contactImg) ? _c('i', {
    staticClass: "el-icon-upload"
  }) : _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.contactImg)
      }
    }
  }), _vm._v(" "), (!_vm.contactImg) ? _c('div', [_vm._v("上传图片")]) : _vm._e()])]), _vm._v(" "), _c('el-upload', {
    ref: "upload_contact",
    staticClass: "upload-demo",
    attrs: {
      "accept": ".jpg,.jpeg,.png",
      "action": _vm.action_contact,
      "auto-upload": false,
      "headers": _vm.headers,
      "show-file-list": false,
      "on-change": _vm.handleChange_contact,
      "before-upload": _vm.beforeUpload_contact,
      "on-success": _vm.uploadSuccess_contact
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)])])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveInformation('ruleForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.roleShow) ? _c('role', {
    attrs: {
      "roleIds": _vm.districtIds,
      "organizationId": _vm.model.organizationId
    },
    on: {
      "func": _vm.getRoleSon,
      "getDatas": _vm.getRoleDatas
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.insuranceShow) ? _c('insurance', {
    on: {
      "func": _vm.getRoleSon3
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.leaderShow) ? _c('leader', {
    attrs: {
      "namesIds": _vm.model.examineLeaderIds
    },
    on: {
      "func": _vm.getRoleSon2
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-932f3dee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/staffManagement/detail.vue
// module id = BhYd
// module chunks = 6